import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { MANAGE_TRACKING_CODE_PATH } from 'constant/appPath';
import useSetTitlePage from 'hook/useSetTitlePage';
import LayoutDefault from 'components/Layout/LayoutDefault';
import FormTrackingCode from 'page/Application/ManageTrackingCode/component/FormTrackingCode';
import useCustomMutateRenderMessage from 'hook/useQuery/useCustomMutateRenderMessage';
import { registerTrackingCode } from 'api/trackingCode/trackingCode.api';
import useErrorCodeTrackingCode from 'page/Application/ManageTrackingCode/hook/useErrorCodeTrackingCode';

const RegisterTrackingCode = () => {
  const { ERROR_CODE_TRACKING_CODE } = useErrorCodeTrackingCode();
  const { useMutationAPIHandleErrorCode, errorMessage } =
    useCustomMutateRenderMessage({ errorCode: ERROR_CODE_TRACKING_CODE });
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();
  const [isDisable, setIsDisable] = useState(false);

  const listItem = useMemo(() => {
    return [
      {
        title: <Link to={'/'}>企業管理</Link>,
      },
      {
        title: (
          <Link to={`/${MANAGE_TRACKING_CODE_PATH}`}>トラッキングコード</Link>
        ),
      },
      {
        title: 'トラッキングコード登録',
      },
    ];
  }, []);

  const {
    mutate: registerTrackingCodeMutate,
    isError,
    isLoading: isLoadingSubmit,
  } = useMutationAPIHandleErrorCode({
    refetchKey: 'registerTrackingCode',
    api: registerTrackingCode,
    messageSuccess: 'トラッキングコードを登録しました。',
    path: `/${MANAGE_TRACKING_CODE_PATH}`,
  });

  const onFinish = (values) => {
    if (isOnline) {
      registerTrackingCodeMutate(values);
    } else {
      errorNetWork();
    }
  };

  useSetTitlePage(`トラッキングコード登録 | Soliton パートナーサイト`, true);

  return (
    <>
      {contextErrorNetWork}
      <Breadcrumb listItem={listItem} titlePage="トラッキングコード登録" />
      <LayoutDefault>
        <FormTrackingCode
          titleForm={
            '変更した内容は画面の下部に「保存」ボタンを押下した場合のみに、保存される。'
          }
          onFinish={onFinish}
          isDisable={isDisable}
          setIsDisable={setIsDisable}
          isOnline={isOnline}
          errorNetWork={errorNetWork}
          errorMessage={errorMessage}
          isError={isError}
          isLoadingSubmit={isLoadingSubmit}
        />
      </LayoutDefault>
    </>
  );
};

export default RegisterTrackingCode;
